import { createSelector } from 'reselect'

import viewTypes from 'helpers/enums/viewTypes'
import activityTypes from 'helpers/enums/activityTypes'

const uiSelector = state => state.ui
const interactiveVideoCreationSelector = state => state.interactiveVideoCreation
const oeqActivitySelector = state => state.creationTool.oeq
const mcqActivitySelector = state => state.creationTool.mcq

const currentActivitySelector = createSelector(
	[
		uiSelector,
		interactiveVideoCreationSelector,
		oeqActivitySelector,
		mcqActivitySelector,
	],
	(
		ui,
		interactiveVideoCreation,
		oeq,
		mcq,
	) => {
		let activity = {}
		let type = ''
		switch (ui.currentView) {
			case viewTypes.INTERACTIVE_VIDEO_CREATION_OEQ:
			case viewTypes.VIDEO_CREATION_OEQ:
			case viewTypes.VIDEO_STANDALONE_CREATION_OEQ:
				activity = oeq
				type = activityTypes.OPEN_ENDED_QUESTION
				break
			case viewTypes.INTERACTIVE_VIDEO_CREATION_MCQ:
			case viewTypes.VIDEO_CREATION_MCQ:
			case viewTypes.VIDEO_STANDALONE_CREATION_MCQ:
				activity = mcq
				type = activityTypes.MULTIPLE_CHOICE_QUESTION
				break
		}

		return {
			type,
			interactiveVideoActivity: interactiveVideoCreation.currentActivity,
			activity,
		}
	}
)

export default currentActivitySelector
